import { useQuery } from '@tanstack/react-query';

import { getAccountFieldHistory } from '~/services/ContractingService';

import type { ContractingFieldHistoryParams } from '~/types/services/contracting';

import { fieldHistoryQueryKeys } from './fieldHistoryQueryKeys';
import { retryUnlessRejected } from './retryUnlessRejected';

export function useGetAccountFieldHistory(
  salesforceAccountId: string | undefined,
  params: ContractingFieldHistoryParams,
) {
  return useQuery({
    queryKey: fieldHistoryQueryKeys.account(salesforceAccountId ?? '', params),
    queryFn: ({ signal }) => getAccountFieldHistory(salesforceAccountId ?? '', params, { signal }),
    enabled: !!salesforceAccountId,
    retry: retryUnlessRejected,
  });
}
